import { select, Select } from './select';
import { draw, drawRegularPolygon, Draw } from './draw';
import { measure } from './measure';
import { modify } from './modify';

import { unByKey } from 'ol/Observable';

const link = (target, otherInteraction) => {
	const interaction = target.interaction;
	const other = otherInteraction.interaction;

	const key = interaction.on('change:active', (e) => {
		if( other.getMap() ) {
			other.getMap().removeInteraction(other);	            
	    }
	    
	   	unByKey(key);
	});
}

const interaction_types = {
	select, Select,
	draw, drawRegularPolygon, Draw, 
	measure,
	modify,
	link	
}

export {
	interaction_types
}